import { configureStore } from '@reduxjs/toolkit';
import { logger } from 'redux-logger';
import { get } from "../utils/storage/localStorage";

import { cartApi } from './cart';
import { productApi } from './product';
import { pricingApi } from './pricing';
import { discountApi } from './discount';
import { vatValidationApi } from './vatValidation';
import { customerApi } from './customer';
import { profileApi } from './profileService';
import { rulesValidatorApi } from './rulesValidator';
import { customerGdprAPI } from './customerGdpr';
import { customizeApi } from './customize';

import applicationSlice from './application';
import shippingSlice from './shippingSlice';
import { loqateApi } from './loqate';
import customerSlice from './customerSlice';
import { recaptchaApi } from './recaptcha';
import {shippingMethodApi} from './shipping';
import { orderApi } from './order';
import { idpApi } from "./idp";
import { adyenLinkApi } from './adyen';
import { brainTreeApi } from './braintree';
import { customerFeedAPI } from './customerFeed';
import { newCartApi } from './newCart';
import { reorderApi } from './reorder';
import { paymentOptionsApi } from './paymentOptions';
import { discountCodeApi } from './discountCode';
import { inventoryApi } from './inventory';
import { mcpCustomWrapperApi } from './mcpCustomWrapper';

let additionalMiddleware: Array<any> = [];
 if (get('enableReduxLogging') === true) {
  additionalMiddleware.push(logger);
}

const store = configureStore({
  reducer: {
    applicationState: applicationSlice.reducer,
    [cartApi.reducerPath]: cartApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [pricingApi.reducerPath]: pricingApi.reducer,
    [discountApi.reducerPath]: discountApi.reducer,
    [loqateApi.reducerPath]: loqateApi.reducer,
    [discountCodeApi.reducerPath]: discountCodeApi.reducer,
    [vatValidationApi.reducerPath]: vatValidationApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [customizeApi.reducerPath]: customizeApi.reducer,
    [rulesValidatorApi.reducerPath]: rulesValidatorApi.reducer,
    [recaptchaApi.reducerPath] : recaptchaApi.reducer,
    [shippingMethodApi.reducerPath]: shippingMethodApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [customerGdprAPI.reducerPath]: customerGdprAPI.reducer,
    [adyenLinkApi.reducerPath]: adyenLinkApi.reducer,
    [brainTreeApi.reducerPath]: brainTreeApi.reducer,
    [idpApi.reducerPath]: idpApi.reducer,
    [customerFeedAPI.reducerPath]: customerFeedAPI.reducer,
    [newCartApi.reducerPath]: newCartApi.reducer,
    [reorderApi.reducerPath]: reorderApi.reducer,
    [paymentOptionsApi.reducerPath]: paymentOptionsApi.reducer,
    [inventoryApi.reducerPath]: inventoryApi.reducer,
    [mcpCustomWrapperApi.reducerPath]: mcpCustomWrapperApi.reducer,
    shippingState: shippingSlice.reducer,
    customerState: customerSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(additionalMiddleware)
      .concat(cartApi.middleware)
      .concat(customerApi.middleware)
      .concat(profileApi.middleware)
      .concat(rulesValidatorApi.middleware)
      .concat(productApi.middleware)
      .concat(pricingApi.middleware)
      .concat(discountApi.middleware)
      .concat(discountCodeApi.middleware)
      .concat(shippingMethodApi.middleware)
      .concat(orderApi.middleware)
      .concat(customerGdprAPI.middleware)
      .concat(adyenLinkApi.middleware)
      .concat(brainTreeApi.middleware)
      .concat(idpApi.middleware)
      .concat(vatValidationApi.middleware)
      .concat(customizeApi.middleware)
      .concat(customerFeedAPI.middleware)
      .concat(loqateApi.middleware)
      .concat(recaptchaApi.middleware)
      .concat(newCartApi.middleware)
      .concat(reorderApi.middleware)
      .concat(paymentOptionsApi.middleware)
      .concat(inventoryApi.middleware)
      .concat(mcpCustomWrapperApi.middleware)
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

